import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { BranchProvider } from "@/contexts/BranchContext";

import Login from "@/pages/Login";
import PersonaSelector from "@/pages/PersonaSelector";
import ClientPreview from "@/pages/ClientPreview";
import Receptionist from "@/pages/Receptionist";
import Stylist from "@/pages/Stylist";
import Billing from "@/pages/Billing";
import FloorMap from "@/pages/FloorMap";
import ShiftManager from "@/pages/ShiftManager";
import OwnerDashboard from "@/pages/OwnerDashboard";
import WaitingDisplay from "@/pages/WaitingDisplay";
import BookPublic from "@/pages/BookPublic";
import CheckIn from "@/pages/CheckIn";
import ProductSales from "@/pages/ProductSales";
import Memberships from "@/pages/Memberships";

function Protected({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <BranchProvider>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<Login />} />
              <Route path="/personas" element={<Protected><PersonaSelector /></Protected>} />
              <Route path="/client" element={<Protected><ClientPreview /></Protected>} />
              <Route path="/receptionist" element={<Protected><Receptionist /></Protected>} />
              <Route path="/stylist" element={<Protected><Stylist /></Protected>} />
              <Route path="/billing" element={<Protected><Billing /></Protected>} />
              <Route path="/floormap" element={<Protected><FloorMap /></Protected>} />
              <Route path="/shifts" element={<Protected><ShiftManager /></Protected>} />
              <Route path="/owner" element={<Protected><OwnerDashboard /></Protected>} />
              <Route path="/products" element={<Protected><ProductSales /></Protected>} />
              <Route path="/memberships" element={<Protected><Memberships /></Protected>} />
              <Route path="/display" element={<WaitingDisplay />} />
              <Route path="/book" element={<BookPublic />} />
              <Route path="/checkin" element={<CheckIn />} />
              <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
            <Toaster
              position="top-right"
              toastOptions={{
                classNames: {
                  success: "gloss-toast-success",
                  error: "gloss-toast-error",
                  info: "gloss-toast-info",
                  default: "gloss-toast-info",
                },
              }}
            />
          </BranchProvider>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
